import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { searchService } from "../services/search.services"
import {
	REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS,
	SEARCH_LOAD_ALL_STORAGE_SEARCHS,
	LOGOUT,
	SAVED_SEARCH_LOAD_ALL,
	DELETE_SEARCH_LOAD,
	SAVE_NEW_SEARCH,
	REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_LOADER,
	REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_FAILED_OR_SUCCESS_LOADER,
} from "../types/index"
import { clearMultibase } from "../actions/multiAiBase"
import axios from "../services/axios"
import { clearLocalStorage, searchTermDeparse, searchTermParse } from "../utils"
import { setSelectedSearch } from "../actions/searchActions"
import { setNotification } from "../actions/notificationActions"
import {
	deleteSearchFailed,
	deleteSearchSuccess,
	saveNewSearchFailed,
	saveNewSearchFailedClear,
	saveNewSearchSuccess,
	savedSearchLoadAll,
} from "../actions/savedSearchActions"

const getSearch = async () => {
	return await axios.get("/search").catch((e) => console.log(e))
}

function* savedSearchFlow(action) {
	try {
		yield put({ type: REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_LOADER, payload: true })
		const response = yield call(getSearch)
		//update response as per the new API change => converting array into string
		const updatedResponse =
			response.data.searches.length > 0 &&
			response.data.searches.map((item, index) => {
				if (Array.isArray(item.params.text)) {
					item.params.text = searchTermDeparse(item.params.text)
				}
				return item
			})

		yield put({
			type: SEARCH_LOAD_ALL_STORAGE_SEARCHS,
			payload: updatedResponse,
		})
	} catch (error) {
		console.log(error)
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
	}
	yield put({ type: REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_FAILED_OR_SUCCESS_LOADER, payload: false })
}

function* savedSearchLoadAllFlow() {
	try {
		const response = yield call(getSearch)
		//update response as per the new API change => converting array into string
		const updatedResponse =
			response.data.searches.length > 0 &&
			response.data.searches.map((item, index) => {
				if (Array.isArray(item.params.text)) {
					item.params.text = searchTermDeparse(item.params.text)
				}
				return item
			})

		yield put({
			type: SEARCH_LOAD_ALL_STORAGE_SEARCHS,
			payload: updatedResponse,
		})
	} catch (error) {
		console.log(error)
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
	}
}

function* deleteSearchLoadFlow(action) {
	const state = yield select()
	const { idSearch } = action.payload
	try {
		const response = yield call(searchService.deleteSearchesList, idSearch)
		if (response.data.success === true) {
			yield put(deleteSearchSuccess(idSearch))
			yield put(savedSearchLoadAll())
			yield put(
				setNotification({
					data: response?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(deleteSearchFailed(response?.data?.message))
			yield put(
				setNotification({
					data: response?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
		}
	} catch (error) {
		console.log(error)
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
	}
}

function* saveNewSearchFlow(action) {
	const state = yield select()
	const { newSearch } = action.payload
	//update request as per the new API change => converting string into array of string
	newSearch.params.text = searchTermParse(newSearch.params.text)
	try {
		const response = yield call(searchService.saveNewSearch, newSearch)
		if (response.data.success === true) {
			yield put({
				type: SAVED_SEARCH_LOAD_ALL,
			})

			yield put(setSelectedSearch(newSearch?.id ? newSearch : response.data.search))
			yield put(saveNewSearchSuccess(response.data))
			yield put(
				setNotification({
					data: response?.data?.message,
					severity: "success",
				})
			)
			//update the searchid in query string
			// const newKay = {
			// 	your_search_id: response.data.search.id,
			// }

			// const queryString = updateQueryString(newKay, ["shared_search_id"])
			// const url = `${window.location.pathname}?${queryString}`
			// history.push(url)
		} else {
			yield put(saveNewSearchFailed(response?.data?.message))
			yield put(
				setNotification({
					data: response?.data?.message,
					severity: "error",
				})
			)
			delay(3000)
			yield put(saveNewSearchFailedClear())
		}
	} catch (error) {
		try {
			yield put(
				setNotification({
					data: "something went wrong",
					severity: "error",
				})
			)
			yield put(saveNewSearchFailed("something went wrong"))
			delay(3000)
			yield put(saveNewSearchFailedClear())

			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
	}
}

// Our watcher (saga).  It will watch for many things.
function* savedSearchWatcher() {
	yield takeLatest(REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS, savedSearchFlow)
	yield takeLatest(SAVED_SEARCH_LOAD_ALL, savedSearchLoadAllFlow)
	yield takeLatest(DELETE_SEARCH_LOAD, deleteSearchLoadFlow)
	yield takeLatest(SAVE_NEW_SEARCH, saveNewSearchFlow)
}

export default savedSearchWatcher
